import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Collapse,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
import "../feedbackList/feedbackListForAdmin.scss";
import FeedbackDetailsForAdmin from "../feedbackList/feedbackDetailsForAdmin";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { allFeedbackList } from "../../service/api/user/allFeedbackList";
import deleteFeedbackApi from "../../service/api/user/deleteFeedbackById";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { getFeedbackById } from "../../service/api/user/getFeedbackById";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import {
  lblEmail,
  lblPhoneNumber,
  txtAction,
  txtCreatedDate,
  txtFeedbackList,
  txtFullName,
  txtNoRecordsFound,
  txtRole,
} from "../../dataBaseFile/label";
import InternationalPhoneFormatFun from "../../ui/InternationalPhoneFormatFun";
import { FaSearch } from "react-icons/fa";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { getPromocodeListApi } from "../../service/api/promocode/getPromocodeList";
import { formatDateCommon } from "../../functions/validations";
import AddOrUpdatePromocode from "./addOrUpdatePromocode";
import deletePromocodeApi from "../../service/api/promocode/deletePromocode";
import { setCurrentPage } from "../../feature/userData/userData";
const ManagePromocode = () => {
  const [basicModal, setBasicModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [skeltonVal, setSkeltonVal] = useState(false);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [elements, setElements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const [sortByValue, setSortByValue] = useState("DESC");
  const [columnName, setColumnName] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [flag, setFlag] = useState(false);
  const [dataToModal, setDataToModal] = useState(false);
  const [handleToaster, setHandleToaster] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [resMessage, setResMessage] = useState("");
  const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);

  const [filtreBox, setFiltreBox] = useState(false);
  const [filtreValue, SetFiltreValue] = useState(1);

  const rows = elements;
  const [promocodeModalStatus, setPromocodeModalStatus] = useState(false);
  const [promoCodeModalType, setPromoCodeModalType] = useState("");
  const [promocodeId, setPromocodeId] = useState("");
  const [promocodeTypeList, setPromocodeTypeList] = useState([])
  const [deletingApi, setDeletingApi] = useState(false)

  const [isExpandedPromoCodeId, setIsExpandedPromoCodeId] = useState('');




  function deletePromocode() {
    setDeletingApi(true)
    let details = {
      promo_code_id_ids: promocodeId,
    };
    dispatch(
      deletePromocodeApi(
        details,
        (res) => {
          setDeletingApi(false)
          setOpenDialog(false);
          setBasicModal(false);

          setResMessage(res.data.message);

          setToasterType("success");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          onLoadData();
        },
        (res) => {
          setDeletingApi(false)
          setOpenDialog(false);

          setResMessage(res.data.message);

          setToasterType("error");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  }

  function getPromocodeDetails(res) {
    // const newElements = [...elements, ...res.data];
    // const uniqueElements = Array.from(
    //   new Set(newElements.map(JSON.stringify))
    // ).map(JSON.parse);
    // setElements(uniqueElements);

    setElements(res.data);

    setTotalNoRecord(res.total_count);
    if (res.total_count % pageSize === 0) {
      setTotalPage(parseInt(res.total_count / pageSize));
    } else {
      setTotalPage(parseInt(res.total_count / pageSize + 1));
    }
  }

  function onLoadData() {
    setCustomeSkeletonLoading(true)
    const data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id"));
    data.append("pagination_flag", 1);
    data.append("page_index", page);
    data.append("page_size", pageSize);
    data.append("sorting_order", sortByValue);
    data.append("sorting_column_name", columnName);
    data.append("search_area", searchValue);
    dispatch(getPromocodeListApi(data, (res) => {
      setPromocodeTypeList(res.data.promo_code_types)
      getPromocodeDetails(res.data)
      setCustomeSkeletonLoading(false)
    }, (err) => {
      setCustomeSkeletonLoading(false)
    }));
  }

  const handleSearch = (e) => {
    setPage(1);
    const ele = [];
    setElements(ele);

    if (searchValue.trim().length >= 2) {
      onChangePage(1);
      setColumnName("");
    }
    setSearchValue(e.target.value);
  };

  const handleChangeRowsPerPage = (e) => {
    // console.log(e)
    setSearchValue("");
    setPage(1);
    setPageSize(e.target.value);
  };

  const onChangePage = (e, p) => {
    // setPage(p);
    setPage(e);
  };

  useEffect(() => {
    onLoadData();
  }, [
    sortByValue,
    pageSize,
    page,
    columnName
  ]);

  const handleColumnName = (name) => {
    setColumnName(name)

    if (sortByValue === "ASC") {
      setSortByValue("DESC")
    }
    if (sortByValue === "DESC") {
      setSortByValue("ASC")
    }
  }

  const handleOrderValue = (order) => {

    setSortByValue(order)
  }


  function onLoadDataSearch() {
    const data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id"));
    data.append("pagination_flag", 1);
    data.append("page_index", page);
    data.append("page_size", pageSize);
    data.append("sorting_order", sortByValue);
    data.append("sorting_column_name", columnName);
    data.append("search_area", searchValue);


    dispatch(getPromocodeListApi(data, (res) => {
      setPromocodeTypeList(res.data.promo_code_types)
      getPromocodeDetails(res.data)
      setCustomeSkeletonLoading(false)
    }, (err) => {
      setCustomeSkeletonLoading(false)
    }));
  }
  useEffect(() => {
    // if (searchValue.trim().length > 2) {
    //   const ele = [];
    //   setPage(1);
    //   setElements(ele);

    //   setFlag(true);
    //   const timeOutId = setTimeout(onLoadSearch, 1000);
    //   return () => clearTimeout(timeOutId);
    // } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
    //   if (flag) {
    //     onLoadData();
    //   }
    // }


    if (searchValue.trim().length > 2) {
      setFlag(true);
      const timeOutId = setTimeout(onLoadDataSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValue.trim().length === 0) {
      if (flag) {
        onLoadDataSearch();
      }
    }

  }, [searchValue]);

  const backToAdminDashboard = () => {
    window.history.back();
  };

  function handleOpenFiltreBox() {
    setFiltreBox(!filtreBox);
  }

  function handleSetFiltreValue(v) {
    SetFiltreValue(v);
    const ele = [];
    setPage(1);
    setElements(ele);
    if (v === 1) {
      setSortByValue("DESC");
    } else if (v === 2) {
      setSortByValue("ASC");
    }
  }

  function handleClose(value) {
    setPromocodeModalStatus(false);
    if (value == "load") {
      setElements([])
      onLoadData()
    }
  }

  const searchAreaVal = (e) => {
    // setSearchArea(e.target.value)
    // if (searchArea.trim().length >= 2) {
    //     onChangePage(1)
    // }

    setSearchValue(e.target.value)
    if (searchValue.trim().length >= 2) {
      onChangePage(1)
    }
  }

  function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);

    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getDate();
    let hour = date.getHours();
    const minute = date.getMinutes();

    const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    const amPm = hour < 12 ? 'am' : 'pm';
    const minuteFormatted = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
  }

  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <div>
      {/* New feedback listing page */}
      <div className="row mx-3 mb-5" style={{}}>
        <div className="col-12 px-0">
          <div className="row mx-0 p-3">
            <div className="col-6 px-0 ps-2 d-flex align-item-center justify-content-start">
              <span className="fs-4 fw-bold text-black">
                {"Promocode list"}
              </span>
            </div>
            <div className="col-6 px-0 pe-2 d-flex align-item-center justify-content-end">
              <button
                onClick={(e) => {
                  setPromocodeModalStatus(true)
                  setPromoCodeModalType("add")
                  setPromocodeId("")
                }}
                className="admin-add-user"
                style={{ width: "auto" }}
                variant="light btn-rounded">
                <i
                  className="bi bi-plus-circle-fill"
                  style={{ marginRight: "10px" }}></i>
                Add Promocode
              </button>
            </div>
          </div>



          <div className='my-3'>
            <PaginationAndSearching
              handleSearch={searchAreaVal}
              // searchValue={searchArea}
              searchValue={searchValue}
              defaultValue={pageSize}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalPage}
              onChange={onChangePage}
            />
          </div>

          <Table responsive>

            <thead>
              <tr className='text-black bg-light'>
                <th

                  style={{ fontWeight: '700' }}

                >
                  Actions
                </th>

                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("promo_code_str") }}
                >
                  Promocode name
                  <span className="ml-1">
                    {columnName === 'promo_code_str' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>
                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("promo_code_type_str") }}
                >
                  Promocode type
                  <span className="ml-1">
                    {columnName === 'promo_code_type_str' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>

                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("charge_amount_float") }}
                >
                  Customer charge amount
                  <span className="ml-1">
                    {columnName === 'charge_amount_float' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>

                <th></th>

              </tr>
            </thead>

            <tbody>
              {customeSkeletonLoading ?
                <SkeletonTableRow cols={5} /> :
                <>
                  {elements?.length > 0 ?
                    <>
                      {elements?.map((element, index) => {
                        return (
                          <>
                            <tr
                              className={`notification-rows font-w700 ${isExpandedPromoCodeId === element.promo_code_id_ids ? "bg-primary text-white " : ""}`}
                              key={index}
                              onClick={() => {
                                // onRowClick(element)
                                if (element?.promo_code_id_ids === isExpandedPromoCodeId) {
                                  setIsExpandedPromoCodeId('')
                                } else {
                                  setIsExpandedPromoCodeId(element.promo_code_id_ids)
                                }
                              }}
                            >
                              <td className="d-flex align-items-center">

                                <div className="me-2">
                                  <div className="tooltipCustom">
                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                    <span
                                      className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                      style={{ height: '35px', width: '35px' }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setPromoCodeModalType("edit");
                                        setPromocodeModalStatus(true);
                                        setPromocodeId(element?.promo_code_id_ids);
                                      }}
                                    >
                                      <i className="bi bi-pencil-square"></i>
                                    </span>
                                  </div>
                                </div>

                                <div className="tooltipCustom">
                                  <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete"}</span>
                                  <span
                                    className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.promo_code_id_ids === isExpandedPromoCodeId ? '' : 'text-danger'} `}
                                    style={{ height: '35px', width: '35px' }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setBasicModal(true);
                                      setPromocodeId(element?.promo_code_id_ids);
                                    }}
                                  >
                                    <i className="bi bi-trash3"></i>
                                  </span>
                                </div>

                              </td>

                              <td>
                                {element.promo_code_str}
                              </td>

                              <td>
                                {element.promo_code_type_str}
                              </td>

                              <td>
                                {`${USDollar.format((element?.charge_amount_float / 100) || 0)}`}
                              </td>

                              <td>
                                {/* <OverlayTrigger placement="top" overlay={tooltip}> */}
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (element?.promo_code_id_ids === isExpandedPromoCodeId) {
                                      setIsExpandedPromoCodeId('')
                                    } else {
                                      setIsExpandedPromoCodeId(element.promo_code_id_ids)
                                    }
                                  }}
                                  className="d-flex align-items-center justify-content-center bg-light rounded-3 overlay-action-btn text-black"
                                  style={{ fontSize: '15px', height: '30px', width: '35px' }}>
                                  {element?.promo_code_id_ids === isExpandedPromoCodeId ? <i class="bi bi-chevron-down"></i> : <i class="bi bi-chevron-right"></i>}
                                </div>
                                {/* </OverlayTrigger> */}
                              </td>
                            </tr>

                            <tr>
                              <td colSpan="7" className={`bg-light ${(element?.promo_code_id_ids !== isExpandedPromoCodeId) ? 'p-0' : ''}`}>
                                <Collapse
                                  in={element?.promo_code_id_ids === isExpandedPromoCodeId}
                                >
                                  <div className='row mx-0'>
                                    <div className='col-12 px-0'>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Created on`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">
                                            {`${element?.created_date_dtm ?
                                              new Intl.DateTimeFormat("en-US", {
                                                year: "numeric",
                                                month: "short",
                                                day: "numeric",
                                                hour: 'numeric',
                                                minute: 'numeric',
                                                hour12: true
                                              }).format(
                                                element?.created_date_dtm * 1000
                                              ) : '-'}`
                                            }</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Updated on`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element?.updated_date_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.updated_date_dtm * 1000
                                            ) : '-'}`
                                          }</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Expiry on`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element?.expiry_date_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.expiry_date_dtm * 1000
                                            ) : '-'}`}
                                          </span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Promocode frequency`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element?.frequency_int ? element?.frequency_int : '-'}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Created by`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element?.created_by_name_chr ? element?.created_by_name_chr : '-'}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Pro will receive`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className=" font-w600" style={{ color: "rgba(45, 204, 99, 1)" }}>{`${USDollar.format((element?.pro_amount_float / 100) || 0)}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Updated by`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">
                                            {element.updated_by_name_chr ? element.updated_by_name_chr : "-"}
                                          </span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Created for name`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">
                                            {element.created_for_name_chr ? element.created_for_name_chr : "-"}
                                          </span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Created for email`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">
                                            {element.email_chr ? element.email_chr : "-"}
                                          </span>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </Collapse>
                              </td>
                            </tr>
                          </>
                        )
                      })}</> :
                    <tr>
                      <td colSpan="5">No Records Found</td>
                    </tr>
                  }
                </>
              }
            </tbody>
          </Table>

        </div>
      </div>

      <AcceptRejectModal
        text={"Are you sure you want to delete this Promocode ?"}
        onClickReject={() => {
          setBasicModal(false);
        }}
        onClickAccept={deletePromocode}
        modalStatus={basicModal}
      />

      {promocodeModalStatus && (
        <AddOrUpdatePromocode
          modalType={promoCodeModalType}
          handleClose={handleClose}
          promocodeModalStatus={promocodeModalStatus}
          promocodeId={promocodeId}
          promocodeTypeList={promocodeTypeList}
        />
      )}

      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={resMessage} />
      )}
    </div>
  );
};

export default ManagePromocode;
